<template>
  <el-form-item :label="$t('taskDetail.' + label)">
    <el-upload
      class="upload-demo"
      style="display: inline-block; margin-right: 10px"
      action=""
      ref="annexFileUploader"
      :on-change="
        (file, fileList) => {
          handleChange(file, fileList);
        }
      "
      :auto-upload="false"
      :limit="1"
      :show-file-list="false"
      :file-list="fileList"
    >
      <div>
        <el-button size="small" type="primary">
          {{
            submitFile ? $t("taskDetail.uploadAgain") : $t("taskDetail.upload")
          }}
        </el-button>

        <span slot="tip" class="el-upload__tip">
          {{ fileLimitTip }}
        </span>
      </div>
    </el-upload>
    <span
      @click="openLink(submitFile)"
      class="copyIcon"
      style="color: #409eff; text-align: left"
      v-if="submitFile"
      >{{ submitFile | fileNameFilter }}
    </span>
    <el-tag type="success" v-if="submitFile">{{
      $t("table.submitted")
    }}</el-tag>
    <el-tag type="danger" v-else>{{ $t("table.unsubmitted") }}</el-tag>
  </el-form-item>
</template>
<script>
import { openLink } from "@/utils/utils";
import { fileNameFilter } from "@/utils/filter";

export default {
  name: "UploadHelper",
  filters: { fileNameFilter },
  props: {
    label: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 3,
    },
    sizeLimit: {
      type: Number, // MB
      default: 1,
    },
    acceptType: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tip: {
      type: String,
      default: "",
    },
    submitFile: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    openLink,
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    handleChange(file, fileList) {
      let typeValid = false;
      for (const type of this.acceptType) {
        if (file.name.endsWith(type)) {
          typeValid = true;
          break;
        }
      }
      const sizeValid = file.size <= 1024 * 1024 * this.sizeLimit;
      if (!(typeValid && sizeValid)) {
        this.$message.warning(this.fileLimitTip);
        fileList.pop();
        return false;
      }
      this.handleUpload(file, fileList);
    },
    handleUpload(file, fileList) {
      fileList.pop();
      this.$emit("onUpload", file);
    },
  },
  computed: {
    fileLimitTip() {
      return this.$t("common.uploadLimit", {
        type: this.acceptType.join(", "),
        size: this.sizeLimit,
      });
    },
  },
};
</script>

<style scoped></style>
